import * as Sentry from '@sentry/vue'
import { Router } from 'vue-router'
import { getPageVersion } from './getPageVersion'
import { createIdleInterval } from './createIdleInterval'

// Extend Performance interface to include memory property (Chrome-specific)
declare global {
  interface Performance {
    memory?: {
      jsHeapSizeLimit: number
      totalJSHeapSize: number
      usedJSHeapSize: number
    }
  }
}

const routesToTrack: Record<string, boolean> = {
  'conversations-id-v2': true,
  'contact_detail-v2': true,
  'opportunities-list-v2': true,
  'dashboard-v2': true,
  'smart-list-v2': true,
}

export const initMemoryUsage = (router: Router) => {
  try {
    createIdleInterval(
      () => {
        try {
          const routeName = router.currentRoute.value?.name
          const routeNameStr = typeof routeName === 'string' ? routeName : String(routeName)
          if (routeName && routesToTrack[routeNameStr]) {
            trackMemoryUsage(router)
          }
        } catch (error) {
          console.error('[MemoryTracking] Error in memory tracking interval:', error)
        }
      },
      { interval: 5 * 60 * 1000, timeout: 2000 }
    )
  } catch (error) {
    console.error('[MemoryTracking] Failed to initialize memory tracking:', error)
  }
}

export const trackMemoryUsage = (router: Router, otherAttributes: { [key: string]: any } = {}) => {
  try {
    // Check if performance.memory API is available (Chrome only)
    if (!window?.performance?.memory) {
      console.warn('[MemoryTracking] performance.memory API not available in this browser')
      return
    }

    const usedJSHeapSize = Math.ceil((window.performance.memory.usedJSHeapSize || 0) / 1024 / 1024)

    // Safely extract route information
    const currentRoute = router.currentRoute.value
    if (!currentRoute) {
      console.warn('[MemoryTracking] Current route not available')
      return
    }

    const routeName = currentRoute.name
    const routePath = currentRoute.path

    if (!routeName || !routePath) {
      console.warn('[MemoryTracking] Route name or path is missing')
      return
    }

    const pageVersion = getPageVersion(currentRoute.params?.location_id, currentRoute.name)

    if (usedJSHeapSize > 0) {
      // try {
      //   Sentry.logger.info('memory usage', {
      //     usedJSHeapSize,
      //     path: routePath,
      //     routeName,
      //     ...(pageVersion && { pageVersion }),
      //     ...otherAttributes,
      //   })
      // } catch (logError) {
      //   console.error('[MemoryTracking] Failed to log to Sentry logger:', logError)
      // }

      try {
        Sentry.metrics.distribution('memory.usedJSHeapSize', usedJSHeapSize, {
          unit: 'MB',
          attributes: {
            path: routePath,
            routeName,
            ...(pageVersion && { pageVersion }),
            ...otherAttributes,
          },
        })
      } catch (metricsError) {
        console.error('[MemoryTracking] Failed to send metrics to Sentry:', metricsError)
      }
    }
  } catch (error) {
    console.error('[MemoryTracking] Error tracking memory usage:', error)
  }
}
